import * as generalApi from './general';
import * as keyResourceApi from './keyResource';
import * as locationApi from './location';
import * as remedyApi from './remedy';

const services = {
    getRemedyList: remedyApi.getList,
    getRemedy: remedyApi.getItem,
    postRemedy: remedyApi.addItem,
    postEditRemedy: remedyApi.editItem,
    
    getLocationList: locationApi.getList,
    getLocationResourceList: locationApi.getItem,
    postLocationResource: locationApi.addItem,
    postEditLocationResource: locationApi.editItem,

    getKeyResourceList: keyResourceApi.getList,
    postKeyResource: keyResourceApi.addItem,
    postEditKeyResource: keyResourceApi.editItem,

    postFeedback : generalApi.feedback,
    getTrackList : generalApi.track,
    getVolunteerList : generalApi.volunteers,

    getStoryList : generalApi.stories,

}

export default services;